import {createUseStyles} from 'react-jss';
import cn from 'classnames';
import React, {FunctionComponent} from 'react';
import {IconProps} from './IconProps';

const IconRingSpinner: FunctionComponent<IconProps> = ({className, height = '1em'}) => {
  const styles = useStyles();

  return (
    <svg height={height} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg"
      className={cn('inline-block', className, styles.icon)}>
      <circle cx="50" cy="50" fill="none" stroke="currentColor" strokeWidth="10" r="35"
        strokeDasharray="164.93361431346415" transform="rotate(11.7691 50 50)">
        <animateTransform
          attributeName="transform"
          type="rotate"
          repeatCount="indefinite"
          dur="1s"
          values="0 50 50;360 50 50"
          keyTimes="0;1"
        />
      </circle>
    </svg>

  );
};

export default IconRingSpinner;

const useStyles = createUseStyles({
  icon: {
    verticalAlign: '-0.125em',
  },
});
